// extracted by mini-css-extract-plugin
export default {"xlArr":"RightArrow_xlArr__CA-XS","lgArr":"RightArrow_lgArr__oHsMg","smArr":"RightArrow_smArr__oebxd"};